<template>
  <div class="home-main">
    <div class="container">
      <section class="home">
        <div class="columns is-desktop is-vcentered">
          <div class="column is-5-desktop catchphrase">
            <h1 class="title is-size-1 is-kabel">
              {{ $t("homepage.title") }}
            </h1>
          </div>
          <div class="column is-offset-1-desktop is-6-desktop">
            <b-carousel :autoplay="false">
              <b-carousel-item>
                <section class="hero is-medium is-primary">
                  <div class="hero-body has-text-centered">
                    <h2 class="title">
                      {{ $t("homepage.aire-educative-description") }}
                    </h2>
                  </div>
                </section>
              </b-carousel-item>
              <b-carousel-item>
                <section class="hero is-medium is-success">
                  <div class="hero-body has-text-centered">
                    <h2 class="title">
                      {{ $t("homepage.venez") }}
                    </h2>
                  </div>
                </section>
              </b-carousel-item>
              <b-carousel-item>
                <section class="hero is-medium is-warning">
                  <div class="hero-body has-text-centered has-direction-column">
                    <h2 class="title">
                      {{ $t("homepage.decouvrez") }}

                      <br />
                    </h2>
                    <b-button tag="a" href="#carte" class="is-primary" size="is-medium">
                      <strong>
                        {{ $t("homepage.decouvrir") }}
                      </strong>
                    </b-button>
                  </div>
                </section>
              </b-carousel-item>
              <b-carousel-item>
                <section class="hero-logos">
                  <img
                    src="@/assets/images/AME.png"
                    alt="Logo Aire Marine Éducative"
                    title="Logo Aire Marine Éducative"
                  />
                  <img
                    src="@/assets/images/ATE.png"
                    alt="Logo Aire Terrestre Éducative"
                    title="Logo Aire Terrestre Éducative"
                  />
                </section>
              </b-carousel-item>
              <b-carousel-item>
                <section class="hero is-medium is-dark contains-image">
                  <img
                    src="@/assets/images/photos/46796.jpg"
                    alt="Photos d'élèves"
                    title="Crédit photo"
                  />
                </section>
              </b-carousel-item>
            </b-carousel>
          </div>
        </div>

        <div class="buttons-container">
          <b-button tag="a" href="#publique" class="is-primary" outlined rounded>
            <strong>{{ $t("homepage.a-qui") }}</strong>
          </b-button>
          <b-button tag="a" href="#chiffres" class="is-primary" outlined rounded>
            <strong>{{ $t("homepage.chiffres") }}</strong>
          </b-button>
          <b-button tag="a" href="#entrer" class="is-primary" outlined rounded>
            <strong>{{ $t("homepage.entrer-demarche") }}</strong>
          </b-button>
          <b-button tag="a" href="#ensuite" class="is-primary" outlined rounded>
            <strong>{{ $t("homepage.apres-compte") }}</strong>
          </b-button>
          <b-button tag="a" href="#membre" class="is-primary" outlined rounded>
            <strong>{{ $t("homepage.membre-grae") }}</strong>
          </b-button>
        </div>
      </section>

      <section id="publique">
        <div class="columns point-important">
          <h2 class="column is-12 title is-size-1">
            {{ $t("homepage.a-qui") }}
          </h2>
        </div>
        <div class="columns">
          <div class="column is-half center">
            <img
              src="@/assets/images/photos/39267.jpg"
              class="photo"
              alt="Photos d'élèves"
              title="Crédit photo"
            />
          </div>
          <div class="column is-half bullet-home">
            <p>
              <b-icon icon="school" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content">
                {{ $t("homepage.toute-classe") }}
              </span>
            </p>
            <p>
              <b-icon icon="chalkboard-teacher" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content">
                {{ $t("homepage.volontaires") }}
              </span>
            </p>
            <p>
              <b-icon icon="child" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content">
                {{ $t("homepage.referent") }}
              </span>
            </p>
            <p>
              <b-icon icon="question-circle" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content">
                {{ $t("homepage.plus-infos") }}

                <span>
                  <b-button
                    type="is-primary is-rounded"
                    tag="a"
                    target="_blank"
                    href="https://ame.ofb.fr/doku.php"
                    style="margin-top: 10px"
                  >
                    {{ $t("homepage.wiki") }}
                  </b-button>
                  <b-button
                    type="is-primary is-rounded"
                    tag="a"
                    target="_blank"
                    href="https://ofb.gouv.fr/aires-educatives"
                    style="margin-left: 20px; margin-top: 10px"
                  >
                    {{ $t("homepage.ofb") }}
                  </b-button>
                </span>
              </span>
            </p>
          </div>
        </div>
      </section>

      <div id="chiffres" class="anchor-hidden"></div>
      <section class="point-chiffres">
        <div class="columns">
          <h2 class="column is-12 title is-size-1 is-kabel">
            {{ $t("homepage.ae-chiffres") }}
          </h2>
        </div>
        <div class="columns">
          <div class="column is-4 center">
            <div class="figure">
              {{
                homepageStats.aireEducativeLabellise ? homepageStats.aireEducativeLabellise : "-"
              }}
            </div>
            {{ $t("homepage.nombre-labellisees") }}
          </div>
          <div class="column is-4 center">
            <div class="figure">{{ homepageStats.nbEleve ? homepageStats.nbEleve : "-" }}</div>
            {{ $t("homepage.nombre-eleves") }}
          </div>
          <div class="column is-4 center">
            <div class="figure">
              {{ homepageStats.newProject ? homepageStats.newProject : "-" }}
            </div>
            {{ $t("homepage.nombre-nouveaux-projets") }}
          </div>
        </div>
      </section>

      <section id="entrer">
        <div class="columns point-important">
          <h2 class="column is-12 title is-size-1">
            {{ $t("homepage.entrer-demarche") }}
          </h2>
        </div>
        <div class="columns">
          <div class="column is-half bullet-home">
            <p>
              <b-icon icon="desktop" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content">
                {{ $t("homepage.cree-compte") }}

                <router-link
                  to="/register/user/0"
                  class="button is-primary"
                  style="vertical-align: baseline"
                >
                  <strong> {{ $t("register") }}</strong>
                </router-link>
                <br />
                <em>{{ $t("homepage.choix-profil") }}</em>
              </span>
            </p>
            <p>
              <b-icon icon="edit" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content">
                {{ $t("homepage.inscription") }} <br />
                <em> {{ $t("homepage.campagne-ouverte") }}</em>
              </span>
            </p>
            <p>
              <b-icon icon="check-square" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content"> {{ $t("homepage.dossier-valide") }} </span>
            </p>
          </div>
          <div class="column is-half center">
            <img
              src="@/assets/images/photos/41964.jpg"
              class="photo"
              alt="Photos d'élèves"
              title="Crédit photo"
            />
          </div>
        </div>
      </section>

      <section id="ensuite">
        <div class="columns point-important">
          <h2 class="column is-12 title is-size-1">{{ $t("homepage.apres-compte") }}</h2>
        </div>
        <div class="columns">
          <div class="column is-half center">
            <img
              src="@/assets/images/photos/41967.jpg"
              class="photo"
              alt="Photos d'élèves"
              title="Crédit photo"
            />
          </div>
          <div class="column is-half bullet-home">
            <p>
              <b-icon icon="people-arrows" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content">
                {{ $t("homepage.accompagne") }}<br />
                <em> {{ $t("homepage.accompagne-reseau") }}</em>
              </span>
            </p>
            <p>
              <b-icon icon="edit" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content">
                {{ $t("homepage.labellisation") }}<br />
                <em> {{ $t("homepage.campagne-ouverte") }} </em>
              </span>
            </p>
            <p>
              <b-icon icon="graduation-cap" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content">
                {{ $t("homepage.projet-labellise") }}<br />
                <em> {{ $t("homepage.poursuivre") }}</em>
              </span>
            </p>
          </div>
        </div>
      </section>

      <section id="membre">
        <div class="columns point-important">
          <h2 class="column is-12 title is-size-1">
            {{ $t("homepage.membre-grae") }} <br /><em>{{ $t("homepage.grae") }}</em>
          </h2>
        </div>
        <div class="columns">
          <div class="column is-half bullet-home">
            <p>
              <b-icon icon="desktop" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content">
                {{ $t("homepage.creation-compte") }}<br />
                <em> {{ $t("homepage.utilisateur") }}</em>
              </span>
            </p>
            <p>
              <b-icon icon="map-marked-alt" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content">
                {{ $t("homepage.rejoins-grae") }}<br />
                <em>{{ $t("homepage.compte-sera-valide") }}</em>
              </span>
            </p>
            <p>
              <b-icon icon="people-arrows" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content"> {{ $t("homepage.voir-grae") }}</span>
            </p>
            <p>
              <b-icon icon="folder-open" size="is-large" class="bullet-marker"></b-icon>
              <span class="is-size-5 bullet-content">
                {{ $t("homepage.instruire") }}<br />
                <em>{{ $t("homepage.types-dossier") }}</em>
              </span>
            </p>
          </div>
          <div class="column is-half center">
            <img
              src="@/assets/images/photos/46284.jpg"
              class="photo"
              alt="Photos d'élèves"
              title="Crédit photo"
            />
          </div>
        </div>
      </section>

      <section id="carte">
        <div class="columns point-important">
          <div class="column">
            <h3 class="column is-12 title">{{ $t("homepage.cartographie") }}</h3>
            <MapClusterComponent />
          </div>
        </div>
      </section>
      <section>
        <div class="columns point-important">
          <div class="column">
            <h3 class="column is-12 title">
              {{ $t("homepage.outils") }}
            </h3>
            <b-button
              type="is-primary is-rounded"
              tag="a"
              target="_blank"
              href="https://ame.ofb.fr/doku.php"
              style="margin-top: 10px"
            >
              {{ $t("homepage.wiki") }}
            </b-button>
            <b-button
              type="is-primary is-rounded"
              tag="a"
              target="_blank"
              href="https://ofb.gouv.fr/aires-educatives"
              style="margin-top: 10px; margin-left: 30px"
            >
              {{ $t("homepage.ofb") }}
            </b-button>
          </div>
        </div>
      </section>
    </div>

    <div v-show="showBackToTop" class="back-to-top-container">
      <a
        href="javascript:void(0)"
        class="back-to-top"
        title="Revenir en haut de la page"
        @click="scrollToTop"
      >
        <b-icon icon="arrow-circle-up" size="is-large"></b-icon>
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import MapClusterComponent from "@/views/maps/MapClusterComponent.vue"
import { LoginService } from "@/services/rest/login/LoginService"
import { HomepageStatsDto, StatService } from "@/services/rest/stats/StatService"
import Events from "@/services/Events"
import { BButton, BIcon, BCarousel } from "buefy"

export default defineComponent({
  name: "HomePage",
  components: {
    MapClusterComponent,
    BButton,
    BIcon,
    BCarousel,
  },
  data() {
    return {
      isUserLoggedIn: false,
      loginService: LoginService.INSTANCE,
      statsService: StatService.INSTANCE,
      homepageStats: new HomepageStatsDto(),
      showBackToTop: false,
      scrollableElement: null as HTMLElement | null,
    }
  },
  created(): void {
    this.refreshUserInfo()
    this.setHomepageStat()
  },
  mounted(): void {
    window.scrollTo(0, 0)
    this.loginService.on(Events.LOGIN_STATUS_CHANGED, () => {
      this.refreshUserInfo()
    })

    // Trouver l'élément scrollable (le .main du parent)
    this.scrollableElement = this.$el.closest(".main")
    if (this.scrollableElement) {
      this.scrollableElement.addEventListener("scroll", this.handleScroll)
    }
  },

  beforeUnmount(): void {
    if (this.scrollableElement) {
      this.scrollableElement.removeEventListener("scroll", this.handleScroll)
    }
  },
  methods: {
    async setHomepageStat(): Promise<void> {
      this.homepageStats = await this.statsService.homepageStats()
    },

    refreshUserInfo(): void {
      const logged = this.loginService.getLoggedUser()
      this.isUserLoggedIn = logged != undefined
    },

    handleScroll: function (this: any): void {
      if (!this.scrollableElement) return

      const scrollTop = this.scrollableElement.scrollTop
      const scrollHeight = this.scrollableElement.scrollHeight
      const clientHeight = this.scrollableElement.clientHeight
      const scrollPercentage = scrollTop / (scrollHeight - clientHeight)

      // Afficher le bouton si on a scrollé plus de 33%
      this.showBackToTop = scrollPercentage > 0.33
    },

    scrollToTop(): void {
      if (!this.scrollableElement) return

      this.scrollableElement.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    },
  },
})
</script>

<style scoped lang="scss">
// Imported to have access to responsive breakpoints
@import "../../node_modules/bulma/sass/utilities/_all.sass";
@import "@/styles/variables.scss";

.home-main {
  position: relative;
}

.home {
  padding-top: 2vh;
}

.home-bullet {
  margin-top: 4vh;
}

.buttons-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

  .button {
    margin: 0 1rem 1rem 1rem;
  }
}

.point-chiffres {
  margin-top: 10vh;
  padding-top: 10vh;
  padding-bottom: 10vh;
  // background-color: $white-ter;
  text-align: center;
}

.center {
  text-align: center;
}

.bullet-home {
  & > p {
    margin-bottom: 1vh;
    display: flex;
    align-items: flex-start;
  }
}

.bullet-marker {
  color: #94c77a;
  padding: 8px;
  flex-shrink: 0;
}

.bullet-content {
  padding-left: 20px;
  padding-top: 10px;
}

.photo {
  border-radius: 10px;
  box-shadow: 0 2px 25px 0 #0002;
  max-width: 90vw;
}

h1,
h2,
h3 {
  font-family: $font-family-title;
}

.figure {
  font-family: $font-family-title;
  font-size: 3rem;
}

.anchor {
  padding-top: $header-big-height;
  margin-top: -1 * $header-big-height;
}

.anchor-hidden {
  height: $header-big-height;
  margin-top: -1 * $header-big-height;
  visibility: hidden;
}

.carousel {
  font-family: $font-family-title;

  .carousel-item {
    height: 400px;

    .hero {
      height: 100%;

      .hero-body {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1.5rem 4rem;
      }

      &.contains-image {
        align-items: center;

        img {
          min-height: 100%;
          min-width: 100%;
          max-width: none;
        }
      }

      .has-direction-column {
        flex-direction: column;
      }
    }

    .hero-logos {
      display: flex;
      align-items: center;
      height: 100%;

      img {
        max-width: 50%;
      }
    }
  }
}

.point-important {
  padding-top: 8vh;
  padding-bottom: 6vh;
  text-align: center;
}

.en-construction {
  color: $dark;
}

.back-to-top-container {
  position: fixed;
  bottom: 50px;
  right: 30px;
  pointer-events: none;
  z-index: 40;
  opacity: 1;
  transition: opacity 0.3s ease;

  &[style*="display: none"] {
    opacity: 0;
    pointer-events: none;
  }
}

.back-to-top {
  position: relative;
  pointer-events: all;
  color: $primary;
  cursor: pointer;
  display: block;
  transition:
    color 0.3s ease,
    transform 0.3s ease;

  &:hover {
    color: $button-hover;
    transform: translateY(-3px);
  }
}

@media screen and (min-width: $desktop) {
  .point-important h2.title {
    position: relative;

    &::before,
    &::after {
      content: "";
      position: absolute;
      width: 50px;
      height: 50px;
      background-size: contain;
      z-index: -1;
    }

    &::before {
      left: 10%;
      top: -30px;
      background-image: url("/img/poisson.svg");
    }

    &::after {
      bottom: -30px;
      right: 10%;
      background-image: url("/img/scarabee.svg");
    }
  }
  .carousel h2.title {
    font-size: 1.8rem;
  }
  .photo {
    max-width: 100%;
  }
}

@media screen and (min-width: $fullhd) {
  .carousel h2.title {
    font-size: 2rem;
  }
}
</style>
